import React from 'react'
import Star from '!!@svgr/webpack!./star.svg'

type StarFractionProps = {
  fraction: number
}

function StarFraction({ fraction }: StarFractionProps) {
  let insetFraction = 1 - fraction
  switch (insetFraction) {
    // 25 percent of the width of the star feels very small so therefore
    // 25% and 75% is transformed to 35% and 65% respectively
    case 0.25:
      insetFraction = 0.35
      break
    case 0.75:
      insetFraction = 0.65
      break
    default:
      break
  }

  return (
    <div className="relative pr-4">
      <Star
        className="block"
        style={{
          clipPath: `inset(0 ${insetFraction * 100}% 0 0)`,
          WebkitClipPath: `inset(0 ${insetFraction * 100}% 0 0)`,
        }}
      />
      <Star className="opacity-25 absolute top-0 block" />
    </div>
  )
}

type Props = {
  rating: number
  big?: boolean
}

function StarRating({ rating, big, ...props }: Props) {
  return (
    <div
      className="flex items-center"
      {...props}
      style={{ transform: big ? 'scale(1.15)' : '' }}
    >
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <StarFraction
            key={index}
            fraction={Math.min(Math.max(rating - index, 0), 1)}
          />
        ))}
    </div>
  )
}

export default StarRating
